<template>
  <section
    id="partners-feedback"
    :class="[
      'section-partners-feedback section-content',
      { 'fade-in': isEnteringSectionPartnersFeedback },
    ]"
  >
    <div class="section-partners-feedback-content">
      <div class="title-wrapper">
        <img class="title-logo" :src="require('@/assets/images/logo.png')" />
        <h2 class="fz-40 fz-mbl-32 fz-mbp-24 fw-700 lh-10 ta-center c-fff">
          Partners' Feedback
        </h2>
      </div>

      <div class="feedback-wrapper">
        <div
          v-for="feedback in feedbackList"
          :key="feedback.name"
          :class="[
            'feedback-block',
            { 'fade-in': isEnteringSectionPartnersFeedback },
          ]"
        >
          <img :src="feedback.tagIcon" class="feedback-block__tag" />

          <div class="feedback-block__information">
            <div class="information-avatar">
              <img
                :src="feedback.avatarImage"
                class="information-avatar-image"
              />
            </div>
            <div class="information-text">
              <h3 class="fz-24 fw-700">{{ feedback.name }}</h3>
              <p class="fz-14 fw-600">{{ feedback.content }}</p>
            </div>
          </div>

          <div class="feedback-block__commission">
            <img
              src="~@/assets/images/section-partners-feedback/icon-triangle.png"
              class="icon-triangle"
            />
            <p class="commission-text fz-18 fw-700 lh-12">
              Average Month Commission: {{ feedback.commissionAmount }}INR
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionPartnersFeedback: {
      type: Boolean,
    },
  },

  data() {
    return {
      feedbackList: [
        {
          tagIcon: require("@/assets/images/section-partners-feedback/tag-icon-1.png"),
          avatarImage: require("@/assets/images/section-partners-feedback/avatar-1.png"),
          name: "Anand Vasani",
          content:
            "GANGA7 is the most professional site for sports betting in India. They really help us build the right marketing strategies to achieve the highest goal and get great returns.",
          commissionAmount: "400,000",
        },
        {
          tagIcon: require("@/assets/images/section-partners-feedback/tag-icon-2.png"),
          avatarImage: require("@/assets/images/section-partners-feedback/avatar-2.png"),
          name: "Nirmal Kurian",
          content:
            "I can access popular and cutting-edge products from GANGA7. Partnership with GANGA7 brings us great satisfaction.",
          commissionAmount: "320,000",
        },
        {
          tagIcon: require("@/assets/images/section-partners-feedback/tag-icon-3.png"),
          avatarImage: require("@/assets/images/section-partners-feedback/avatar-3.png"),
          name: "Jawahar Lal Nehru",
          content:
            "After deciding to become a GANGA7 partner, we have experienced significant profits. We highly recommend GANGA7 partnership program.",
          commissionAmount: "450,000",
        },
        {
          tagIcon: require("@/assets/images/section-partners-feedback/tag-icon-4.png"),
          avatarImage: require("@/assets/images/section-partners-feedback/avatar-4.png"),
          name: "Sanjay Bharat Vadgama",
          content:
            "GANGA7 gives us a lot of benefits by offering high standard service. And we really consistently get commission monthly. Thank you GANGA7.",
          commissionAmount: "120,000",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.section-partners-feedback {
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 40px 5%;

  background-image: url(~@/assets/images/section-partners-feedback/partners-feedback-background.png);
  background-repeat: no-repeat;
  background-position: center 0;
  background-size: cover;

  transition: all 0.5s 0.3s;

  opacity: 0;

  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: linear-gradient(
      0deg,
      rgba(4, 12, 26, 0.9) 0%,
      rgba(0, 0, 0, 0) 50%,
      rgba(4, 12, 26, 1) 100%
    );

    content: "";
  }

  &.fade-in {
    opacity: 1;
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .title-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .title-logo {
      @include mq(dsk) {
        height: 40px;
        margin-right: 18px;
      }

      height: 24px;
      margin-right: 8px;
    }
  }

  .feedback-wrapper {
    @include mq(dsk) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(5, 1fr);
      gap: 76px;

      margin-top: 85px;
    }

    display: grid;
    gap: 36px;
    justify-content: center;

    margin-top: 45px;

    .feedback-block {
      @include mq(dsk) {
        &:nth-child(1) {
          grid-column: 1 / span 1;
          grid-row: 1 / span 2;
          justify-self: flex-end;

          transition: all 0.5s 0.3s;
        }
        &:nth-child(2) {
          grid-column: 2 / span 1;
          grid-row: 2 / span 2;

          transition: all 0.5s 0.6s;
        }
        &:nth-child(3) {
          grid-column: 1 / span 1;
          grid-row: 3 / span 2;
          justify-self: flex-end;

          transition: all 0.5s 0.9s;
        }
        &:nth-child(4) {
          grid-column: 2 / span 1;
          grid-row: 4 / span 2;

          transition: all 0.5s 1.2s;
        }
      }

      @include mq(mbp) {
        padding: 20px 26px;
      }

      position: relative;

      max-width: 512px;
      padding: 38px 26px 20px;

      border: 2px solid #ffe48c;
      border-radius: 20px;
      background: linear-gradient(
        140deg,
        #ffd078 0%,
        #ffdb87 50%,
        #e3b427 100%
      );

      opacity: 0;

      &.fade-in {
        opacity: 1;
      }

      &__tag {
        position: absolute;
        top: -6px;
        right: 26px;

        height: 45px;
      }

      &__information {
        @include mq(dsk) {
          display: flex;
        }

        .information-avatar {
          @include mq(mbp) {
            width: 105px;
            height: 105px;
          }

          display: flex;
          justify-content: center;
          align-items: center;

          flex-shrink: 0;

          width: 135px;
          height: 135px;
          margin: 0 auto;
          padding: 2px;

          border-radius: 100%;
          background: linear-gradient(
            0deg,
            #fff3a6 10%,
            #f5d974 35%,
            #d9b249 45%,
            #c5952a 50%,
            #b98417 55%,
            #b57e10 60%,
            #e5c35c 75%,
            #f9df7b 80%,
            #eccd67 85%,
            #dcb64e 90%,
            #c6972b 95%,
            #b57e10 100%
          );
          box-shadow: 1px 4px 10px rgba(0, 0, 0, 0.35);

          overflow: hidden;

          &-image {
            @include mq(mbp) {
              width: 100px;
              height: 100px;
            }

            width: 130px;
            height: 130px;

            border-radius: 100%;
          }
        }

        .information-text {
          @include mq(dsk) {
            margin-top: 0;
            padding-left: 24px;
          }

          margin-top: 10px;

          color: #403838;
        }
      }

      &__commission {
        display: flex;
        align-items: center;

        margin-top: 20px;
        padding: 8px 16px;

        border-radius: 50px;
        background: linear-gradient(180deg, #363636 0%, #2b1616 100%);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

        .icon-triangle {
          width: 10px;
        }

        .commission-text {
          margin-left: 12px;

          background-image: var(--gradient-2);
          background-clip: text;

          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
}
</style>
